import styled from 'styled-components'
import { Modal } from 'react-responsive-modal'
import media from 'styled-media-query'
import InputCurrency from 'react-intl-currency-input'

export const Container = styled(Modal)``

export const Content = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
`

export const Header = styled.header`
  display: flex;
  gap: 1rem;
  flex-direction: column;

  h1 {
    font-weight: bold;
    font-size: 2rem;

    color: ${(props) => props.theme.colors.text.cards};
  }

  p {
    font-size: 1.8rem;

    color: ${(props) => props.theme.colors.text.cards};
  }
`

export const Form = styled.form`
  display: flex;
  gap: 2rem;
  flex-direction: column;
`

export const ColWrapper = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr 1fr;
  /* grid-template-columns: 1fr 1fr auto; */
`

export const Col = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;

  ${media.lessThan('medium')`
    margin-top: 2rem;
  `}
`

export const Label = styled.label`
  margin-bottom: 1rem;
`

export const Input = styled.input`
  display: block;
  width: 100%;
  height: calc(4rem + 2px);
  padding: 1rem 1.2rem;
  font-size: 1.5rem;
  color: #cad2db;
  background-color: #020216e8;
  background-clip: padding-box;
  border: 2px solid #222;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: 0.4s;

  outline: none;

  &:hover,
  &:focus {
    border: 2px solid #2d81d3;
  }

  &.is-invalid {
    border-color: ${(props) => props.theme.colors.red};
  }
`

export const InputMoney = styled(InputCurrency)`
  display: block;
  width: 100%;
  height: calc(4rem + 2px);
  padding: 1rem 1.2rem;
  font-size: 1.5rem;
  color: #cad2db;
  background-color: #020216e8;
  background-clip: padding-box;
  border: 2px solid #222;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: 0.4s;

  outline: none;

  &:hover,
  &:focus {
    border: 2px solid #2d81d3;
  }

  &.is-invalid {
    border-color: ${(props) => props.theme.colors.red};
  }
`

export const RadioGroup = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-direction: column;

  > label {
    cursor: pointer;
    display: flex;
    gap: 1rem;
    align-items: baseline;

    input {
      width: 1.5rem;
      height: 1.5rem;

      flex-shrink: 0;
    }
  }
`

export const Select = styled.select`
  display: block;
  width: 100%;
  height: calc(4rem + 2px);
  padding: 1rem 1.2rem;
  font-size: 1.5rem;
  color: #cad2db;
  background-color: #020216e8;
  background-clip: padding-box;
  border: 2px solid #222;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: 0.4s;

  outline: none;

  &:hover,
  &:focus {
    border: 2px solid #2d81d3;
  }

  &.is-invalid {
    border-color: ${(props) => props.theme.colors.red};
  }
`

export const ButtonConvert = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: #020216e8;
  border-radius: 0.5rem;
  padding: 1rem;

  > svg {
    width: 2rem;
    height: 2rem;

    color: #ffffff;
  }
`

export const MethodAdding = styled.div`
  display: flex;
  flex-direction: column;

  > button {
    font-size: 1.8rem;

    color: ${({ theme }) => theme.colors.text.cards};

    margin-top: 2rem;
  }
`

export const Methods = styled.div`
  display: flex;
  flex-direction: column;
`

export const ButtonRemove = styled.button`
  position: absolute;
  top: 0;
  right: 0;

  > svg {
    width: 2rem;
    height: 2rem;

    color: ${({ theme }) => theme.colors.text.cards};
  }
`

export const Method = styled.div`
  position: relative;
  display: flex;
  gap: 1rem;
  flex-direction: column;

  min-width: 0;
  word-wrap: break-word;
  background-color: #1b242f;
  background-clip: initial;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 1rem;

  box-shadow: 0 6px 18px rgb(0 0 0 / 6%);
  transition: all 0.15s ease;

  position: relative;
  width: 100%;

  padding: 1.5rem;

  ${media.lessThan('medium')`
    width: auto;
    padding: 2rem;
  `}

  &:not(:first-child) {
    margin-top: 1rem;
  }

  > div {
    display: flex;

    > div:last-child {
      margin-left: 1rem;
    }
  }
`

export const Buttons = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: flex-end;
  align-items: center;
`

interface ButtonProps {
  cancel?: boolean
}

export const Button = styled.button<ButtonProps>`
  color: ${(props) => props.theme.colors.text.cards};
  background-color: ${(props) =>
    props.cancel ? props.theme.colors.red : props.theme.colors.green};
  border-color: ${(props) => props.theme.colors.green};

  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);

  min-width: 12rem;

  font-weight: 600;
  text-align: center;

  border: 1px solid transparent;
  padding: 1rem 2rem;
  font-size: 1.8rem;
  border-radius: 0.5rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:hover:not(:disabled) {
    color: #f7fdff;
    opacity: 0.9;
  }
`
